const ToastType = {
  success: 1,
  warning: 2,
  error: 3,
};

export default ToastType;
